import { environmentProd } from "./environment.prod";
import { environmentStaging } from "./environment.staging";
export const environment = () => {
    switch (process.env.REACT_APP_ENV) {
        case 'staging':
            return environmentStaging;
        case 'production':
            return environmentProd;
        default: return environmentStaging;
    }
}
